$( document ).ready(function() {
  $('#sawmillSelect').click(function(){
    jQuery.post('/cart/update.js', "attributes[store]=sawmill");
    $('#storeMessage').html('Dublin, OH - Sawmill');
    $('.store-select-button').removeClass('selected');
    $('.store-select-button').html('Select');
    $('#sawmillSelect .store-select-button').addClass('selected');
    $('#sawmillSelect .store-select-button').html('Your store');
  });
  $('#eastonSelect').click(function(){
    jQuery.post('/cart/update.js', "attributes[store]=easton");
    $('#storeMessage').html('Columbus, OH - Easton');
    $('.store-select-button').removeClass('selected');
    $('.store-select-button').html('Select');
    $('#eastonSelect .store-select-button').addClass('selected');
    $('#eastonSelect .store-select-button').html('Your store');
  });
  $('#nashvilleSelect').click(function(){
    jQuery.post('/cart/update.js', "attributes[store]=nashville");
    $('#storeMessage').html('Nashville, TN - Green Hills');
    $('.store-select-button').removeClass('selected');
    $('.store-select-button').html('Select');
    $('#nashvilleSelect .store-select-button').addClass('selected');
    $('#nashvilleSelect .store-select-button').html('Your store');
  });
  $('#tulsaSelect').click(function(){
    jQuery.post('/cart/update.js', "attributes[store]=tulsa");
    $('#storeMessage').html('Tulsa, OK - Cherry Street');
    $('.store-select-button').removeClass('selected');
    $('.store-select-button').html('Select');
    $('#tulsaSelect .store-select-button').addClass('selected');
    $('#tulsaSelect .store-select-button').html('Your store');
  });
});
